//Function to check if the user permission
export const checkUserPermission = (permissionCode, permissions) => {
    let permition = permissions.map(element => element.code).indexOf(permissionCode);
    return permition
}